import { Adapter as r } from "../../../adapter.js";
import { TicketSummaryModel as t } from "./ticketSummary.model.js";
class s extends r {
  adapt(e) {
    return new t({
      currency: e.currency,
      discountAmount: e.discount_amount,
      paymentFee: e.payment_fee,
      rawServiceFee: e.raw_service_fee,
      serviceFee: e.service_fee,
      subtotal: e.subtotal,
      taxes: e.taxes,
      taxInPrices: e.tax_in_prices,
      tip: e.tip,
      total: e.total
    });
  }
  serialize(e) {
  }
}
export {
  s as TicketSummaryAdapter
};
//# sourceMappingURL=ticketSummary.adapter.js.map
